import React from 'react';
import jsPDF from 'jspdf';

const DevisPDFGenerator = () => {
  
  const generatePDF = async (devisData) => {
    // Create new PDF document
    const doc = new jsPDF();
    
    console.log("PDF Generation started with data:", devisData); // Debug
    
    // Set document properties
    doc.setProperties({
      title: `${devisData.numero || 'Document'} - ${devisData.recipient_nom || 'Client'}`,
      creator: 'Easy Power CRM',
      author: 'EASY PV'
    });

    // Company logo (base64 encoded from the provided URL)
    try {
      // Use local logo
      const logoResponse = await fetch('/logo.png');
      const logoBlob = await logoResponse.blob();
      
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      return new Promise((resolve) => {
        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          
          const logoDataUrl = canvas.toDataURL('image/png');
          
          // Add logo to PDF (ratio 3.2:1 pour éviter tout écrasement)
          doc.addImage(logoDataUrl, 'PNG', 20, 10, 80, 25);
          
          // Company info (top right) - couleur verte comme le logo
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(45, 150, 60); // Couleur verte du logo EASY POWER
          doc.text('Émetteur', 140, 20);
          
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(0, 0, 0); // Retour au noir pour les détails
          doc.text('SARL EASY PV', 140, 27);
          doc.text('129 RUE SERVIENT', 140, 32);
          doc.text('69003 LYON - France', 140, 37);
          doc.text('contact@easy-power.fr', 140, 42);
          doc.text('04 65 84 83 05', 140, 47);
          
          // Document title and number - couleur verte comme le logo
          doc.setFontSize(20);
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(45, 150, 60); // Couleur verte du logo
          const docType = devisData.type === 'devis' ? 'DEVIS' : 'FACTURE';
          doc.text(docType, 20, 70);
          
          doc.setFontSize(12);
          doc.setTextColor(45, 150, 60); // Couleur verte du logo
          doc.text(`N° ${devisData.numero}`, 20, 78);
          
          // Client info
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(0, 0, 0); // Noir pour Client
          doc.text('Client:', 20, 95);
          
          doc.setFont('helvetica', 'normal');
          doc.text(devisData.recipient_nom || 'Nom non disponible', 20, 102);
          if (devisData.recipient_adresse) doc.text(devisData.recipient_adresse, 20, 107);
          if (devisData.recipient_code_postal && devisData.recipient_ville) {
            doc.text(`${devisData.recipient_code_postal} ${devisData.recipient_ville}`, 20, 112);
          }
          if (devisData.recipient_email) doc.text(devisData.recipient_email, 20, 117);
          
          // Dates
          doc.text(`Date d'émission: ${new Date(devisData.date_creation).toLocaleDateString('fr-FR')}`, 140, 102);
          if (devisData.date_echeance) {
            doc.text(`Date d'échéance: ${new Date(devisData.date_echeance).toLocaleDateString('fr-FR')}`, 140, 107);
          }
          
          // Items table header - couleur verte pour les en-têtes
          let currentY = 135;
          doc.setFont('helvetica', 'bold');
          doc.setFillColor(240, 240, 240);
          doc.rect(20, currentY - 5, 170, 8, 'F');
          
          doc.setTextColor(45, 150, 60); // Couleur verte du logo pour les en-têtes
          doc.text('Description', 25, currentY);
          doc.text('Qté', 120, currentY);
          doc.text('P.U. HT', 135, currentY);
          doc.text('TVA', 155, currentY);
          doc.text('Total TTC', 170, currentY);
          
          currentY += 15;
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(0, 0, 0); // Retour au noir pour le contenu des articles
          
          // Items
          devisData.items.forEach((item) => {
            if (currentY > 250) {
              doc.addPage();
              currentY = 30;
            }
            
            // Description (with text wrapping if needed)
            const splitDescription = doc.splitTextToSize(item.libelle, 90);
            doc.text(splitDescription, 25, currentY);
            
            // Other fields (avec protection contre null/undefined)
            doc.text((item.quantite || 0).toString(), 120, currentY);
            doc.text(`${(parseFloat(item.prix_unitaire) || 0).toFixed(2)}€`, 135, currentY);
            doc.text(`${(parseFloat(item.taux_tva) || 0)}%`, 155, currentY);
            doc.text(`${(parseFloat(item.montant_ttc) || 0).toFixed(2)}€`, 170, currentY);
            
            const lineHeight = Math.max(8, splitDescription.length * 4);
            currentY += lineHeight;
            
            // Separator line
            doc.setDrawColor(220, 220, 220);
            doc.line(20, currentY - 2, 190, currentY - 2);
            currentY += 5;
          });
          
          // Totals
          currentY += 10;
          doc.setFont('helvetica', 'bold');
          
          doc.text('Sous-total HT:', 130, currentY);
          doc.text(`${(parseFloat(devisData.sous_total_ht) || 0).toFixed(2)}€`, 170, currentY);
          
          currentY += 8;
          doc.text('Total TVA:', 130, currentY);
          doc.text(`${(parseFloat(devisData.total_tva) || 0).toFixed(2)}€`, 170, currentY);
          
          currentY += 8;
          doc.setFontSize(12);
          doc.text('TOTAL TTC:', 130, currentY);
          doc.text(`${(parseFloat(devisData.total_ttc) || 0).toFixed(2)}€`, 170, currentY);
          
          // Notes
          if (devisData.notes) {
            currentY += 20;
            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.text('Notes:', 20, currentY);
            
            currentY += 8;
            doc.setFont('helvetica', 'normal');
            const splitNotes = doc.splitTextToSize(devisData.notes, 170);
            doc.text(splitNotes, 20, currentY);
            currentY += splitNotes.length * 4;
          }
          
          // Conditions - nouvelles conditions de paiement
          currentY += 10;
          doc.setFontSize(8);
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(0, 0, 0);
          const conditions = devisData.conditions || "Pénalités de retard : trois fois le taux annuel d'intérêt légal en vigueur calculé depuis la date d'échéance jusqu'à complet paiement du prix.\nIndemnité forfaitaire pour frais de recouvrement en cas de retard de paiement : 40 €\nDate et signature précédées de la mention\n« Bon pour accord »";
          const splitConditions = doc.splitTextToSize(conditions, 170);
          doc.text(splitConditions, 20, currentY);
          
          // Footer - Company legal info
          const pageHeight = doc.internal.pageSize.height;
          doc.setFontSize(8);
          doc.setFont('helvetica', 'normal');
          
          const footerText = "EASY PV | SARL unipersonnelle au capital social de 92 640,00 € | N° SIREN 393.295.811 | N° de TVA FR09393295811";
          const footerWidth = doc.getTextWidth(footerText);
          const centerX = (doc.internal.pageSize.width - footerWidth) / 2;
          
          doc.text(footerText, centerX, pageHeight - 15);
          
          // Save PDF
          doc.save(`${devisData.numero}.pdf`);
          
          resolve(doc);
        };
        
        img.src = URL.createObjectURL(logoBlob);
      });
      
    } catch (error) {
      console.error('Error loading logo:', error);
      
      // Generate PDF without logo if loading fails
      generatePDFWithoutLogo(doc, devisData);
    }
  };

  const generatePDFWithoutLogo = (doc, devisData) => {
    // Company info (top right) - couleur verte comme le logo
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(45, 150, 60); // Couleur verte du logo EASY POWER
    doc.text('Émetteur', 140, 20);
    
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0); // Retour au noir pour les détails
    doc.text('SARL EASY PV', 140, 27);
    doc.text('129 RUE SERVIENT', 140, 32);
    doc.text('69003 LYON - France', 140, 37);
    doc.text('contact@easy-power.fr', 140, 42);
    doc.text('04 65 84 83 05', 140, 47);
    
    // Document title and number - couleur verte comme le logo
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(45, 150, 60); // Couleur verte du logo
    const docType = devisData.type === 'devis' ? 'DEVIS' : 'FACTURE';
    doc.text(docType, 20, 70);
    
    doc.setFontSize(12);
    doc.setTextColor(45, 150, 60); // Couleur verte du logo
    doc.text(`N° ${devisData.numero}`, 20, 78);
    
    // Client info
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0); // Noir pour Client
    doc.text('Client:', 20, 95);
    
    doc.setFont('helvetica', 'normal');
    doc.text(devisData.recipient_nom || 'Nom non disponible', 20, 102);
    if (devisData.recipient_adresse) doc.text(devisData.recipient_adresse, 20, 107);
    if (devisData.recipient_code_postal && devisData.recipient_ville) {
      doc.text(`${devisData.recipient_code_postal} ${devisData.recipient_ville}`, 20, 112);
    }
    if (devisData.recipient_email) doc.text(devisData.recipient_email, 20, 117);
    
    // Dates
    doc.text(`Date d'émission: ${new Date(devisData.date_creation).toLocaleDateString('fr-FR')}`, 140, 102);
    if (devisData.date_echeance) {
      doc.text(`Date d'échéance: ${new Date(devisData.date_echeance).toLocaleDateString('fr-FR')}`, 140, 107);
    }
    
    // Items table header - couleur verte pour les en-têtes
    let currentY = 135;
    doc.setFont('helvetica', 'bold');
    doc.setFillColor(240, 240, 240);
    doc.rect(20, currentY - 5, 170, 8, 'F');
    
    doc.setTextColor(45, 150, 60); // Couleur verte du logo pour les en-têtes
    doc.text('Description', 25, currentY);
    doc.text('Qté', 120, currentY);
    doc.text('P.U. HT', 135, currentY);
    doc.text('TVA', 155, currentY);
    doc.text('Total TTC', 170, currentY);
    
    currentY += 15;
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0); // Retour au noir pour le contenu des articles
    
    // Items
    if (devisData.items && devisData.items.length > 0) {
      devisData.items.forEach((item) => {
        if (currentY > 250) {
          doc.addPage();
          currentY = 30;
        }
        
        const splitDescription = doc.splitTextToSize(item.libelle, 90);
        doc.text(splitDescription, 25, currentY);
        
        doc.text((item.quantite || 0)?.toString() || '0', 120, currentY);
        doc.text(`${(parseFloat(item.prix_unitaire) || 0).toFixed(2)}€`, 135, currentY);
        doc.text(`${(parseFloat(item.taux_tva) || 0)}%`, 155, currentY);
        doc.text(`${(parseFloat(item.montant_ttc) || 0).toFixed(2)}€`, 170, currentY);
        
        const lineHeight = Math.max(8, splitDescription.length * 4);
        currentY += lineHeight;
        
        doc.setDrawColor(220, 220, 220);
        doc.line(20, currentY - 2, 190, currentY - 2);
        currentY += 5;
      });
    } else {
      doc.text('Aucun article', 25, currentY);
      currentY += 15;
    }
    
    // Totals
    currentY += 10;
    doc.setFont('helvetica', 'bold');
    
    doc.text('Sous-total HT:', 130, currentY);
    doc.text(`${(parseFloat(devisData.sous_total_ht) || 0).toFixed(2)}€`, 170, currentY);
    
    currentY += 8;
    doc.text('Total TVA:', 130, currentY);
    doc.text(`${(parseFloat(devisData.total_tva) || 0).toFixed(2)}€`, 170, currentY);
    
    currentY += 8;
    doc.setFontSize(12);
    doc.text('TOTAL TTC:', 130, currentY);
    doc.text(`${(parseFloat(devisData.total_ttc) || 0).toFixed(2)}€`, 170, currentY);
    
    // Notes
    if (devisData.notes) {
      currentY += 20;
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text('Notes:', 20, currentY);
      
      currentY += 8;
      doc.setFont('helvetica', 'normal');
      const splitNotes = doc.splitTextToSize(devisData.notes, 170);
      doc.text(splitNotes, 20, currentY);
      currentY += splitNotes.length * 4;
    }
    
    // Conditions - nouvelles conditions de paiement
    currentY += 10;
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    const conditions = devisData.conditions || "Pénalités de retard : trois fois le taux annuel d'intérêt légal en vigueur calculé depuis la date d'échéance jusqu'à complet paiement du prix.\nIndemnité forfaitaire pour frais de recouvrement en cas de retard de paiement : 40 €\nDate et signature précédées de la mention\n« Bon pour accord »";
    const splitConditions = doc.splitTextToSize(conditions, 170);
    doc.text(splitConditions, 20, currentY);
    
    // Footer - Company legal info
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    
    const footerText = "EASY PV | SARL unipersonnelle au capital social de 92 640,00 € | N° SIREN 393.295.811 | N° de TVA FR09393295811";
    const footerWidth = doc.getTextWidth(footerText);
    const centerX = (doc.internal.pageSize.width - footerWidth) / 2;
    
    doc.text(footerText, centerX, pageHeight - 15);
    
    // Save PDF
    doc.save(`${devisData.numero}.pdf`);
  };

  return { generatePDF };
};

export default DevisPDFGenerator;